import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { SaeIntegrationsHttpService } from './sae-integrations.http';
import { objectToCamel, objectToSnake } from 'ts-case-convert';
import {
  IListQuery,
  IPageResponse,
  IPaginatedList,
  ISaeIntegrationDetail,
  ISaeIntegrationSavePayload,
} from 'src/app/models';
import { UtilsService } from '../utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class SaeIntegrations {

  constructor(
    private saeIntegrationsHttpService: SaeIntegrationsHttpService,
    private utilsService: UtilsService,
  ) { }

  async getSaes() {
    const source$ = this.saeIntegrationsHttpService.getSaes();
    const response = await lastValueFrom(source$);
    const saesArray = objectToCamel(response as []);
    return saesArray;
  }

  async searchSaeIntegrations(query: IListQuery): Promise<IPaginatedList<ISaeIntegrationDetail>> {
    const queryParams = this.utilsService.toQueryParams(query);
    const response = await lastValueFrom(this.saeIntegrationsHttpService.searchSaeIntegrations(queryParams));
    const saeIntegrations = objectToCamel(response as object) as { data: IPageResponse<ISaeIntegrationDetail> };
    return this.utilsService.getDataWithPagination(saeIntegrations.data, query.page);
  }

  async getSaeIntegration(saeIntegrationId: number): Promise<ISaeIntegrationDetail> {
    const response = await lastValueFrom(this.saeIntegrationsHttpService.getSaeIntegration(saeIntegrationId));
    return objectToCamel(response as object) as ISaeIntegrationDetail;
  }

  async saveSaeIntegration(
    saeIntegration: ISaeIntegrationSavePayload,
    saeIntegrationId?: number,
  ): Promise<ISaeIntegrationDetail> {
    const body = objectToSnake(saeIntegration);
    const source$ = saeIntegrationId
      ? this.saeIntegrationsHttpService.updateSaeIntegration(saeIntegrationId, body)
      : this.saeIntegrationsHttpService.createSaeIntegration(body);
    const response = await lastValueFrom(source$);
    return objectToCamel(response as object) as ISaeIntegrationDetail;
  }

  async deleteSaeIntegration(saeIntegrationId: number) {
    await lastValueFrom(this.saeIntegrationsHttpService.deleteSaeIntegration(saeIntegrationId));
  }
}
